export default {
  text: {
    en: 'Continue cancellation',
  },
}
